import { useEffect } from 'react';

import { useCollaboratorStore } from '@/stores/database/entities/00-RBAC/99-Collaborators';
import { ResourceType } from '@/stores/database/entities/00-RBAC/99-Collaborators/types';

export const getResourceKey = (resourceType: ResourceType, resourceId: string) => `${resourceType}:${resourceId}`;

export function useResourceCollaborators(resourceType: ResourceType, resourceId?: string) {
    const key = resourceId ? `${resourceType}:${resourceId}` : undefined;

    const collaborators = useCollaboratorStore((s) => (key ? s.collaborators[key] : undefined));
    const requestStatus = useCollaboratorStore((s) => (key ? s.requestStatus[key] : undefined));
    const fetchCollaborators = useCollaboratorStore((s) => s.fetchCollaborators);

    useEffect(() => {
        if (resourceId && !requestStatus) {
            void fetchCollaborators(resourceType, resourceId);
        }
    }, [fetchCollaborators, requestStatus, resourceId, resourceType]);

    return {
        collaborators,
        loading: requestStatus === 'loading',
    };
}

export function useEnsureCollaborators(resourceType: ResourceType, resourceId: string) {
    const key = getResourceKey(resourceType, resourceId);

    const requestStatus = useCollaboratorStore((s) => s.requestStatus[key]);
    const fetchCollaborators = useCollaboratorStore((s) => s.fetchCollaborators);

    useEffect(() => {
        if (!requestStatus) {
            void fetchCollaborators(resourceType, resourceId);
        }
    }, [fetchCollaborators, requestStatus, resourceId, resourceType]);
}
